import React, { useState } from "react";
import GenericForm, { FormFieldConfig } from "../../../../components/genericform/GenericForm";
import ImageUploader from "../../ImageUploader";
import { StaffDialogProps, StaffFormData } from "src/shared/services/interfacev2";

interface AddStaffDialogProps extends StaffDialogProps {
  onAddStaff: (formData: StaffFormData) => Promise<boolean>;
}

const AddStaffDialog: React.FC<AddStaffDialogProps> = ({ open, onClose, onAddStaff }) => {
  const initialState: StaffFormData = {
    firstName: "",
    middleName: "",
    lastName: "",
    phoneNumber: "",
    emails: "",
    image: null,
  };

  const [formData, setFormData] = useState<StaffFormData>(initialState);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handlePhoneChange = (val: string) => {
    const cleaned = val.replace(/\D/g, "").slice(0, 8);
    setFormData((prev) => ({ ...prev, phoneNumber: cleaned }));
  };

  const fields: FormFieldConfig[] = [
    {
      id: "firstName",
      label: "First Name",
      required: true,
      value: formData.firstName,
      onChange: (val: string) => setFormData((prev) => ({ ...prev, firstName: val })),
    },
    {
      id: "middleName",
      label: "Middle Name",
      value: formData.middleName,
      onChange: (val: string) => setFormData((prev) => ({ ...prev, middleName: val })),
    },
    {
      id: "lastName",
      label: "Last Name",
      value: formData.lastName,
      onChange: (val: string) => setFormData((prev) => ({ ...prev, lastName: val })),
    },
    {
      id: "phoneNumber",
      label: "Phone Number",
      type: "text",
      required: true,
      value: formData.phoneNumber,
      onChange: handlePhoneChange,
    },
    {
      id: "emails",
      label: "Email",
      type: "email",
      value: formData.emails,
      onChange: (val: string) => setFormData((prev) => ({ ...prev, emails: val })),
    },
    {
      id: "image",
      type: "custom",
      gridSpan: 2,
      render: <ImageUploader value={formData.image} onChange={(file) => setFormData((p) => ({ ...p, image: file }))} />,
    },
  ];

  const handleSubmit = async () => {
    if (isSubmitting) return; // Prevent double click

    setIsSubmitting(true);

    try {
      const success = await onAddStaff(formData);

      if (success) {
        setFormData(initialState);
        onClose();
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    if (!isSubmitting) {
      setFormData(initialState);
      onClose();
    }
  };

  const isFormValid = () => formData.firstName.trim() !== "" && formData.phoneNumber.length === 8;

  return (
    <GenericForm
      open={open}
      title="Add Staff"
      fields={fields}
      onClose={handleClose}
      onSubmit={handleSubmit}
      isFormValid={isFormValid}
      confirmLabel="Confirm"
      cancelLabel="Cancel"
      isLoading={isSubmitting}
    >
      {/* <div className="mt-2">

      <ImageUploader value={formData.image} onChange={(file) =>
        setFormData((prev) => ({ ...prev, image: file }))
      } />
      </div> */}
    </GenericForm>
  );
};

export default AddStaffDialog;
